export const PROJECT_GUIDE = 'Project Guide';
export const BUYING_GUIDE = 'Buying Guide';
export const INSTALLATION_SERVICES = 'Installation Services';
export const TOOL_RENTAL = 'Tool Rental';
export const FULL_CARD = 'full';
export const RENTAL_CARD = 'rental';

const INSTALL_TYPE = 'install';

export function getCardType(type) {
  switch (type) {
  case PROJECT_GUIDE:
    return 'guide';
  case BUYING_GUIDE:
    return 'guide';
  case INSTALLATION_SERVICES:
  case INSTALL_TYPE:
    return 'install';
  case TOOL_RENTAL:
    return 'rental';
  default:
    return null;
  }
}

export const transformContentServicesForModelInterpretation = (content) => {
  if (!content) return null;

  return {
    universalSearchArray: [
      {
        pods: [{
          title: content?.title,
          description: content?.description,
          imageUrl: content?.imageUrl,
          link: content?.link,
          recordType: content?.recordType,
        }],
        info: {
          title: content?.podTitle,
          type: content?.type,
        }
      }
    ],
    productTypes: []
  };

};
